import {
  CreativeElementDto,
  DeleteCreativeElementResponseDto,
  PagedCreativeElementsRequestDto,
  PagedCreativeElementsResponseDto,
} from "@repo/api/creative-element";
import { AmplifilesClient } from "./api-client";

export class CreativeElementApi {
  static async getPagedCreativeElements(
    teamExternalId: string,
    body: PagedCreativeElementsRequestDto,
  ): Promise<PagedCreativeElementsResponseDto> {
    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/creative-elements-paged`,
      body,
    );

    return PagedCreativeElementsResponseDto.parse(response.data);
  }

  static async uploadCreativeElement(
    teamExternalId: string,
    file: File,
  ): Promise<CreativeElementDto> {
    const formData = new FormData();
    formData.append("image", file);

    const response = await AmplifilesClient.instance.post(
      `/team/${teamExternalId}/creative-element`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      },
    );

    return CreativeElementDto.parse(response.data);
  }

  static async deleteCreativeElement(
    teamExternalId: string,
    elementExternalId: string,
  ): Promise<DeleteCreativeElementResponseDto> {
    const response = await AmplifilesClient.instance.delete(
      `/team/${teamExternalId}/creative-element/${elementExternalId}`,
    );

    return DeleteCreativeElementResponseDto.parse(response.data);
  }
}
